import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"
import { useQuery } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import { DataTable } from "./partial/DataTable"
import { columns } from "./partial/Columns"

const getListKelompokVerifikasiPesertaSuratKeteranganSehat = async (
  id_verbutawarna_rekap: string
) => {
  const response = await api.get(
    `/setting/verifikator-surat-keterangan-sehat/show-kelompok/${id_verbutawarna_rekap}`,
    {
      withCredentials: true,
    }
  )
  return response.data
}

export default function SettingVerifikatorSuratKeteranganSehatDetailPage() {
  const [searchParams] = useSearchParams()
  const idVerSehatRekap = searchParams.get("id")

  const { data, isPending } = useQuery({
    queryKey: [
      "listKelompokVerifikasiPesertaSuratKeteranganSehat",
      idVerSehatRekap,
    ],
    queryFn: () =>
      getListKelompokVerifikasiPesertaSuratKeteranganSehat(
        String(idVerSehatRekap)
      ),
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  )
}
